import React from 'react';
import {
  EligibilityOverviewProvider,
} from 'dtos/eligibilityOverviewProvider';
import Section from 'views/EMR/components/Eligibility/Overview/Section';
import Field from 'views/EMR/components/Eligibility/Overview/Field';

type Props = {
  provider: EligibilityOverviewProvider;
};

export default function Provider({ provider }: Props) {
  const {
    firstName,
    middleName,
    lastName,
    organizationName,
    npi,
  } = provider;

  return (
    <Section title="Provider">
      <div className="flex flex-wrap gap-x-6 gap-y-3">
        <Field label="First name" value={firstName} />
        <Field label="Middle name" value={middleName} />
        <Field label="Last name" value={lastName} />
        <Field label="Organization name" value={organizationName} />
        <Field label="NPI" value={npi} />
      </div>
    </Section>
  );
}
